import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import {
  editUserBasicInfo,
  getUserDetails,
  assignGroups
} from '../../../common/service/user';
import STATUS_CODE from '../../../../request/statusCode';
import {
  RESET,
  SET_PERMISSION,
  SET_USER_DETAILS,
  SET_LOADING
} from './actionTypes';
import { ACTION_TYPE_MAP, INITIAL_DETAILS, PERMISSION_TYPE } from './consts';
import { assignPolicies } from './service';
import { getPermission } from '../../../../store/permission/actions';
import { ACCOUNT_STATE } from '../../../common/components/UserBasicInfo/consts';
import { getUserAction } from './helpers';

const reset = createAction(RESET);

const setUserDetails = createAction(SET_USER_DETAILS);

const setPermission = createAction(SET_PERMISSION);

const setLoading = createAction(SET_LOADING);

const getDetails = ({ userName }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getUserDetails({ userName }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const {
          name,
          displayName,
          telephone,
          email,
          company,
          projects,
          status,
          isLocked,
          passwordStatus,
          groups,
          policies,
          contractNumber,
          adName,
          wiwName
        } = res.data;
        return dispatch(
          setUserDetails({
            name,
            displayName,
            telephone,
            email,
            company,
            projects,
            status,
            isLocked,
            passwordStatus,
            groups,
            policies,
            contractNumber,
            adName,
            wiwName
          })
        );
      }
      return dispatch(setUserDetails(INITIAL_DETAILS));
    });
  };
};

const editBasicInfo = ({
  name,
  displayName,
  telephone,
  email,
  company,
  contractNumber,
  projectName
}) => {
  return dispatch => {
    return editUserBasicInfo({
      name,
      displayName,
      telephone,
      email,
      company,
      contractNumber,
      projectName
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('User edited successfully !');
        dispatch(getDetails({ userName: name }));
        return true;
      }
      return false;
    });
  };
};

const editGroups = data => {
  return (dispatch, getState) => {
    return assignGroups(data).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Group updated successfully !');
        const { name } = getState().userDetailsCommonInfo;
        dispatch(getDetails({ userName: name }));
        return true;
      }
      return false;
    });
  };
};

const editPolicies = data => {
  return (dispatch, getState) => {
    return assignPolicies(data).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Policy updated successfully !');
        const { name } = getState().userDetailsCommonInfo;
        dispatch(getDetails({ userName: name }));
        return true;
      }
      return false;
    });
  };
};

const getUserPermission = ({ projectName, status }) => {
  return dispatch => {
    let types = [PERMISSION_TYPE.EDIT];
    if (status === ACCOUNT_STATE.APPLYING) {
      types = [...types, PERMISSION_TYPE.REVIEW_REGISTRATION];
    }
    const actions = types.map(type => {
      return getUserAction({
        actions: [ACTION_TYPE_MAP[type]],
        project: projectName
      });
    });
    dispatch(
      getPermission({
        types,
        actions,
        setPermission
      })
    );
  };
};

export {
  getDetails,
  setUserDetails,
  reset,
  editBasicInfo,
  editGroups,
  editPolicies,
  setPermission,
  getUserPermission,
  setLoading
};
